import type { LengthDiscount } from "@/features/diets/types/length-discount.type";

/**
 * Highest percentage the catering's length-discount tiers can reach.
 * Returns undefined when there are no tiers to advertise.
 */
export const getMaxLengthDiscount = (
  lengthDiscounts?: LengthDiscount | null,
): number | undefined => {
  const discounts = lengthDiscounts?.discounts ?? [];

  if (discounts.length === 0) return undefined;

  return Math.max(...discounts.map((tier) => tier.discount));
};
